import Observer from '../../common/scripts/observer';

const observer = new Observer();

export class ButtonShare {
    constructor() {
        /**
         * Обёртка над элементами
         * @type {null | node}
         */
        this.buttonWrapper = null;

        this.links = {
            vk      : 'https://vk.com/share.php?url',
            ok      : 'https://connect.ok.ru/offer?url',
            telegram: 'https://telegram.me/share/url?url',
            whatsapp: 'https://api.whatsapp.com/send/?text',
            zen     : 'https://zen.yandex.ru/media/?'
        };

        this.options = 'sharer,status=0,toolbar=0,width=650,height=500';

        /**
         * Элемент по которому кликают
         * @type {null}
         */
        this.button = null;

        /**
         * Элемент по которому кликают для закрытия тултипа
         * @type {null}
         */
        this.buttonClose = null;

        /**
         * Элемент, который появляется после клика
         * @type {null}
         */
        this.tooltip = null;

        /**
         * Ссылки на соц. сети
         * @type {null}
         */
        this.socialLinks = null;

        /**
         * Оверлей для скрытия тултипа при клике мимо
         * @type {null}
         */
        this.overlay = null;

        /**
         * css-класс для состояния открытия
         * @type {string}
         */
        this.classStateVisible = `is-visible`;

        /**
         * Состояния кнопки
         * open - открывает
         * close - закрывает
         * @type {string}
         */
        this.state = null;
    }

    /**
     * Инициализирует компонент
     * @param {Object} options - объект настроек
     */
    init(options) {
        this.buttonWrapper = options.target;
        this.button = this.buttonWrapper.querySelector('.j-button-share');
        this.tooltip = this.buttonWrapper.querySelector('.j-button-share-tooltip');
        this.buttonClose = this.tooltip.querySelector('.j-button-share-close-tooltip');
        this.socialLinks = [...this.tooltip.querySelectorAll('.j-button-share-social-item')];
        this.overlay = this.buttonWrapper.querySelector('.j-button-share-overlay');

        this.state = this.tooltip.classList.contains(this.classStateVisible) ? 'open' : 'close';

        this._bindEvents();
        this._subscribes();
    }

    /**
     * Навешивает слушателей на элементы
     * @private
     */
    _bindEvents() {
        if (this.button) {
            this.button.addEventListener('click', this._toggleClickBind.bind(this));
        }

        if (this.buttonClose) {
            this.buttonClose.addEventListener('click', this._closeClickBind.bind(this));
        }

        if (this.socialLinks.length) {
            this.socialLinks.forEach((link) => {
                link.addEventListener('click', this._socialClickBind.bind(this));
            });
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', this._closeClickBind.bind(this));
        }
    }

    /**
     * Метод содержит в себе колбэки на события других модулей.
     * @private
     */
    _subscribes() {
        observer.subscribe('scrollByStart', () => {
            this.state = 'close';
            this.tooltip.classList.remove(this.classStateVisible);
        });
    }

    /**
     * Обрабатывает клик для открытия/закрытия
     * @private
     */
    _toggleClickBind() {
        if (this.state === 'close') {
            this._openTooltip();
            this.state = 'open';
        } else {
            this._closeTooltip();
            this.state = 'close';
        }
    }

    /**
     * Обрабатывает клик для закрытия
     * @private
     */
    _closeClickBind() {
        if (this.state === 'open') {
            this._closeTooltip();
            this.state = 'close';
        }
    }

    // eslint-disable-next-line valid-jsdoc
    /**
     * Обрабатывает клик для соц. сети
     * @private
     */
    _socialClickBind(event) {
        const social = event.currentTarget.dataset.social ? event.currentTarget.dataset.social : null;
        const URL = `${this.links[social]}=${window.location.href}`;

        this._closeClickBind();

        if (this.links[social]) {
            window.open(URL, '_blank', this.options);
        }
    }

    /**
     * Изменяет классы на элементе с открытого на закрытое и открытое
     * @private
     */
    _openTooltip() {
        this.tooltip.classList.add(this.classStateVisible);
        this.buttonWrapper.classList.add(this.classStateVisible);
    }

    _closeTooltip() {
        this.tooltip.classList.remove(this.classStateVisible);
        this.buttonWrapper.classList.remove(this.classStateVisible);
    }
}
